import { DeleteIcon } from '@chakra-ui/icons';
import {
  Alert,
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  AlertIcon,
  Box,
  Button,
  Checkbox,
  CheckboxGroup,
  Flex,
  FormControl, FormLabel,
  IconButton,
  Input,
  Menu, MenuButton,
  MenuItem,
  MenuList,
  Select,
  Spinner,
  Switch,
  Table, Tbody,
  Td,
  Text, Th, Thead, Tr,
  VStack,
  useColorModeValue,
  Link as ChakraLink,
} from '@chakra-ui/react';
import axios from 'axios';
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import AppConfig from "config";
import FichasController from "controllers/Fichas/FichasController";
import JobsController from "controllers/Jobs/JobsController";
import RepositoriosController from "controllers/Repositorios/RepositoriosController";
import { useEffect, useState } from 'react';
import FullScreenModal from "./components/ModalFiles";
import { Link } from 'react-router-dom';
import CampanhasController from "controllers/Campanhas/CampanhasController";

function Jobs() {
  const [data, setData] = useState([]);
  const textColor = useColorModeValue("gray.700", "white");
  const [repos, setRepos] = useState([]);
  const [queues, setQueues] = useState([]);
  const [audits, setAudits] = useState([]);
  const [files, setFiles] = useState([]);
  const [campanhas, setCampanhas] = useState([]);
  const [, setResultados] = useState({});
  const [selectedRepoPath, setSelectedRepoPath] = useState('');
  const [loading, setLoading] = useState(false);
  const [uploadAlert, setUploadAlert] = useState(null);
  const [selectedIntegration, setSelectedIntegration] = useState('');
  const [confirmacaoAberta, setConfirmacaoAberta] = useState(false);
  const [fileToUpload, setFileToUpload] = useState(null);
  const [selectedAudits, setSelectedAudits] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModalUplaod, setShowModalUpload] = useState(false);
  const [setSelectedId] = useState('');
  const [error, setError] = useState('');
  const [filterState, setFilterState] = useState(1);

  const abrirConfirmacao = () => {
    document.getElementById('fileInput').click();
  };

  const handleFileInputChange = (e) => {
    const filesArray = Array.from(e.target.files);
    setFileToUpload(filesArray);
    if (filesArray.length > 0) {
      setConfirmacaoAberta(true);
    }
  };

  const handleOpenModal = async () => {
    setShowModal(true);
  };

  const handleOpenModalUploadFiles = async () => {
    setShowModalUpload(true);
  };

  const LoadingIndicator = ({ isLoading }) => {
    return (
      <Box
        position="fixed"
        top="270px"
        right="300px"
        display={isLoading ? 'block' : 'none'}
        color="#90cdf4;"
      > Carregando <Spinner size="sm" />
      </Box>
    );
  };

  const [newJob, setNewJob] = useState({
    job_name: '',
    audit_name: '',
    audit_id: '',
    repo_name: '',
    transcript_only: 0,
    integration: '',
    qtd_protocol: '',
    protocol_code: '',
    queue: '',
    start_date: '',
    end_date: '',
    ismeta: '',
    id_campanha: ''
  });

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const jobs = await JobsController.ListJobs(filterState);
        setData(jobs);
        const files = await JobsController.ListFilesIntegrationXcall();
        setFiles(files)
        const campanha = await CampanhasController.ListCampaigns();
        setCampanhas(campanha)
        const queues = await JobsController.ListQueues();
        setQueues(queues);
      } catch (error) {
        console.error("Error fetching jobs:", error);
      }
    };

    const fetchRepos = async () => {
      try {
        const response = await RepositoriosController.ListRepositorios();
        setRepos(response);
      } catch (error) {
        console.error("Error fetching repos:", error);
      }
    };

    const fetchAudits = async () => {
      try {
        const response = await FichasController.ListFichas();
        setAudits(response);
      } catch (error) {
        console.error("Error fetching audit_cadastro:", error);
      }
    };
    fetchJobs();
    fetchRepos();
    fetchAudits();
  }, [filterState]);

  const handleAddJob = async () => {
    const selectedRepo = repos.find(r => r.reponame === newJob.repo_name);
    const selectedAudit = audits.find(audit => audit.Nome);
    const selectedAuditIds = selectedAudits.map(audit => audit.id);
    const selectedAuditNames = selectedAudits.map(audit => audit.Nome);
    const selectedCampanha = campanhas.map(audit => audit.Nome);

    if (!newJob.id_campanha) {
      setError('Por favor, selecione uma campanha.');
      return;
    }
    setError('');

    try {
      const response = await JobsController.AddJobs(newJob.job_name, selectedAuditIds, selectedAuditNames, newJob.repo_name, selectedRepo ? selectedRepo.repos_path : '', selectedIntegration, newJob.qtd_protocol, newJob.protocol_code, newJob.queue, newJob.start_date, newJob.end_date, newJob.meta, newJob.id_campanha)

      if (!response) {
        throw new Error("Failed to add job.");
      }

      const updatedJobsResponse = await JobsController.ListJobs(filterState);
      setData(updatedJobsResponse);

      setSelectedIntegration('')

      setNewJob({
        job_name: '',
        audit_name: '',
        audit_id: '',
        repo_name: '',
        integration: '',
        qtd_protocol: '',
        protocol_code: '',
        queue: '',
        start_date: '',
        end_date: ''
      });

      setShowModal(false);
    } catch (error) {
      console.error("Error adding job:", error);
    }
  };

  const toggleJobState = async (job) => {
    const newState = job.state === 1 ? 0 : 1;

    const updatedJob = {
      ...job,
      state: newState
    };

    setData((prevData) => {
      return prevData.map((item) => {
        if (item.idtranscript_scheduller === job.idtranscript_scheduller) {
          return updatedJob;
        }
        return item;
      });
    });

    try {
      const response = await JobsController.PutJobs(job.idtranscript_scheduller, newState)

      if (!response || response.error) {
        throw new Error(response.message || 'Failed to update job state.');
      }

      console.log(`Successfully toggled state for job ID: ${job.idtranscript_scheduller}`);
      
      const updatedJobsResponse = await JobsController.ListJobs(filterState);
      setData(updatedJobsResponse);
    } catch (error) {
      console.error('Error updating job state:', error);
      setData((prevData) => {
        return prevData.map((item) => {
          if (item.idtranscript_scheduller === job.idtranscript_scheduller) {
            return { ...item, state: job.state };
          }
          return item;
        });
      });
    }
  };

  const toggleTranscriptOnly = async (job) => {
    const newTranscriptOnlyValue = job.transcript_only === 1 ? 0 : 1;

    const updatedJob = {
      ...job,
      transcript_only: newTranscriptOnlyValue,
    };

    try {
      const response = await fetch(AppConfig.BACKEND_URL + `/jobs/${job.idtranscript_scheduller}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updatedJob),
      });

      if (!response.ok) {
        throw new Error('Failed to update job.');
      }
      console.log(`Successfully toggled state for job ID: ${job.idtranscript_scheduller}`);

      setData((prevData) => prevData.map((item) => item.idtranscript_scheduller === job.idtranscript_scheduller ? updatedJob : item));
    } catch (error) {
      console.error('Error updating job:', error);
    }
  };

  const handleFileUpload = async () => {
    if (!fileToUpload || !selectedRepoPath) return;

    const batchSize = 1000;
    const jwtToken = localStorage.getItem('access_token');

    try {
      setLoading(true);

      const fileList = Array.from(fileToUpload);

      for (let i = 0; i < fileList.length; i += batchSize) {
        const batchFiles = fileList.slice(i, i + batchSize);

        const formData = new FormData();

        for (const file of batchFiles) {
          formData.append('file', file);
        }

        formData.append('repos_path', selectedRepoPath);

        const response = await axios.post(AppConfig.BACKEND_URL_REFATORADO + `scheduling_page/upload`, formData, {

          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${jwtToken}`,
          },
        });

        if (response.status !== 200) {
          throw new Error('Failed to upload files.');
        }
      }

      setLoading(false);

      setUploadAlert(
        <Alert status="success">
          <AlertIcon />
          Arquivos carregados com sucesso!
        </Alert>
      );
    } catch (error) {
      setUploadAlert(
        <Alert status="error">
          <AlertIcon />
          Arquivos não foram carregados, contate o administrador!
        </Alert>
      );
    } finally {
      setLoading(false);

      setTimeout(() => {
        setUploadAlert(null);
      }, 5000);
    }
  };
  const deleteFicha = async (job) => {
    try {
      const response = await JobsController.DeleteJobs(job.idtranscript_scheduller)
      if (response) {
        const updatedJobsResponse = await JobsController.ListJobs(filterState);
        setData(updatedJobsResponse);
      } else {
        throw new Error('Failed to delete job.');
      }
    } catch (error) {
      console.error("Error deleting job:", error);
    }
  };

  const fetchUpdatedJobs = async () => {
    try {
      const response = await JobsController.ListJobs(filterState);
      setData(response);
    } catch (error) {
      console.error("Error fetching updated jobs:", error);
    }
  };

  useEffect(() => {
    const interval = setInterval(fetchUpdatedJobs, 10000);

    return () => clearInterval(interval);
  }, [filterState]);

  return (

    <Flex direction='column' height="100%" width="100%">
      <Card overflowX={{ sm: "scroll", xl: "hidden" }}>
        <CardHeader>
          <VStack spacing={2} align="stretch">
            <Flex justify="space-between">
              <Button colorScheme="blue" width="auto" minWidth="150px" flexShrink={0} flexGrow={1} borderRadius="lg" marginRight={2} onClick={handleOpenModal}>
                Adicionar
              </Button>
              <Button colorScheme="blue" width="auto" minWidth="150px" flexShrink={0} flexGrow={1} borderRadius="lg" marginRight={2} onClick={handleOpenModalUploadFiles}>
                Carregar Arquivos
              </Button>
              <Flex>
                <FullScreenModal />
                <Button 
                  colorScheme={filterState === 1 ? "gray" : "green"} 
                  width="auto" 
                  minWidth="150px" 
                  flexShrink={0} 
                  flexGrow={1} 
                  borderRadius="lg" 
                  marginLeft={2}
                  onClick={() => setFilterState(filterState === 1 ? 0 : 1)}
                >
                  {filterState === 1 ? "Mostrar Inativos" : "Mostrar Ativos"}
                </Button>
              </Flex>
            </Flex>
            {showModal && (
              <AlertDialog isOpen={showModal} onClose={() => setShowModal(false)}>
                <AlertDialogOverlay>
                  <AlertDialogContent>
                    <AlertDialogHeader fontSize="lg" fontWeight="bold">
                      Novo Agendamento
                    </AlertDialogHeader>
                    <AlertDialogBody>
                      <FormControl mb={4}>
                        <FormLabel>Nome</FormLabel>
                        <Input
                          width="360px"
                          placeholder="Nome"
                          value={newJob.job_name}
                          onChange={(e) => setNewJob({ ...newJob, job_name: e.target.value })}
                        />
                      </FormControl>
                      <Menu mb={4}>
                        <FormLabel>Selecione a ficha</FormLabel>
                        <MenuButton as={Select} placeholder={"Selecionar Fichas"} colorScheme="blue" width="360px" mb={4} />
                        <MenuList maxH="200px" overflowY="auto">
                          <CheckboxGroup value={selectedAudits} onChange={setSelectedAudits}>
                            {audits.map(audit => (
                              <MenuItem key={audit.id}>
                                <Checkbox
                                  value={audit}
                                  isChecked={selectedAudits.some(selectedAudit => selectedAudit.id === audit.id)}
                                  onChange={e => {
                                    if (e.target.checked) {
                                      setSelectedAudits([...selectedAudits, audit]);
                                    } else {
                                      setSelectedAudits(selectedAudits.filter(selectedAudit => selectedAudit.id !== audit.id));
                                    }
                                  }}
                                >
                                  {audit.Nome}
                                </Checkbox>
                              </MenuItem>
                            ))}
                          </CheckboxGroup>
                        </MenuList>
                      </Menu>
                      <FormLabel>Selecione a Campanha</FormLabel>
                      <Select
                        placeholder="Selecionar Campanha"
                        value={newJob.id_campanha}
                        onChange={(e) => setNewJob({ ...newJob, id_campanha: e.target.value })}
                        style={{ width: '360px' }}
                        mb={4}
                      >
                        {campanhas.map(repo => (
                          <option key={repo.idcampanhas} value={repo.idcampanhas}>
                            {repo.campanha_nome}
                          </option>
                        ))}
                      </Select>

                      {error && (
                        <Alert status="error" mb={4}>
                          <AlertIcon />
                          {error}
                        </Alert>
                      )}
                      <FormLabel>Selecione a origem</FormLabel>
                      <Select placeholder="Origem" value={selectedIntegration} onChange={(e) => setSelectedIntegration(e.target.value)} mb={4}>
                        <option value="1">Chat2Flow</option>
                        <option value="2">Gravação</option>
                        <option value="3">Integração Xcall</option>
                        <option value="4">Conversa de texto (chat, whatsapp, etc)</option>
                        <option value="5">Gravação + Metadado</option>
                        <option value="6">Conversa de texto + Metadado</option>
                      </Select>
                      {selectedIntegration == '1' && (
                        <Input
                          placeholder="Quantidade Protocolo"
                          value={newJob.qtd_protocol}
                          onChange={(e) => setNewJob({ ...newJob, qtd_protocol: e.target.value })}
                          disabled={selectedIntegration === '2'}
                          mb={4}
                        />
                      )}
                      {selectedIntegration == '1' && (
                        <Input
                          placeholder="Código de Protocolo"
                          value={newJob.protocol_code}
                          onChange={(e) => setNewJob({ ...newJob, protocol_code: e.target.value })}
                          disabled={selectedIntegration === '2'}
                          mb={4}
                        />
                      )}
                      {selectedIntegration == '1' && (
                        <Select
                          placeholder="Selecionar Fila"
                          value={newJob.queue}
                          onChange={(e) => setNewJob({ ...newJob, queue: e.target.value })}
                          style={{ width: '360px' }}
                          disabled={selectedIntegration === '2'}
                          mb={4}
                        >
                          {queues.map(repo => <option key={repo.context_id} value={repo.context_id}>{repo.context_name}</option>)}
                        </Select>
                      )}
                      {selectedIntegration == '1' && (
                        <Input
                          type="date"
                          placeholder="Data Inicio"
                          value={newJob.start_date}
                          onChange={(e) => setNewJob({ ...newJob, start_date: e.target.value })}
                          disabled={selectedIntegration === '2'}
                          mb={4}
                        />
                      )}
                      {selectedIntegration == '1' && (
                        <Input
                          type="date"
                          placeholder="Data Fim"
                          value={newJob.end_date}
                          onChange={(e) => setNewJob({ ...newJob, end_date: e.target.value })}
                          disabled={selectedIntegration === '2'}
                          mb={4}
                        />
                      )}
                      {selectedIntegration == '2' && (
                        <Select
                          placeholder="Selecionar repositório"
                          value={newJob.repo_name}
                          onChange={(e) => setNewJob({ ...newJob, repo_name: e.target.value })}
                          style={{ width: '360px' }}
                          disabled={selectedIntegration === '1'}
                          mb={4}
                        >
                          {repos.map(repo => <option key={repo.id_repos} value={repo.reponame}>{repo.reponame}</option>)}
                        </Select>
                      )}
                      {selectedIntegration == '2' && (
                        <Select
                          placeholder="Metadados?"
                          value={newJob.meta}
                          onChange={(e) => setNewJob({ ...newJob, meta: e.target.value })}
                          style={{ width: '360px' }}
                          mb={4}
                        >
                          <option value="1">Sim</option>
                          <option value="0">Não</option>
                        </Select>
                      )}
                      {selectedIntegration == '3' && (
                        <Menu mb={4}>
                          <FormLabel>Selecione o repositório</FormLabel>
                          <Select
                            placeholder="Selecionar repositório"
                            value={newJob.repo_name}
                            onChange={(e) => setNewJob({ ...newJob, repo_name: e.target.value })}
                            style={{ width: '360px' }}
                            disabled={selectedIntegration === '1'}
                            mb={4}
                          >
                            {repos.map(repo => <option key={repo.id_repos} value={repo.reponame}>{repo.reponame}</option>)}
                          </Select>
                          {/* <FormLabel>Selecione os arquivos</FormLabel>
                          <MenuButton as={Select} placeholder={"Selecionar Arquivos"} colorScheme="blue" width="360px" mb={4}>
                          </MenuButton>
                          <MenuList>
                            <CheckboxGroup value={selectedAudits} onChange={setSelectedAudits}>
                              {files.map(audit => (
                                <MenuItem key={audit.id}>
                                  <Checkbox
                                    value={audit}
                                    isChecked={selectedAudits.some(selectedAudit => selectedAudit.id === audit.id)}
                                    onChange={e => {
                                      if (e.target.checked) {
                                        setSelectedAudits([...selectedAudits, audit]);
                                      } else {
                                        setSelectedAudits(selectedAudits.filter(selectedAudit => selectedAudit.id !== audit.id));
                                      }
                                    }}
                                  >
                                    {audit.arquivo}
                                  </Checkbox>
                                </MenuItem>
                              ))}

                            </CheckboxGroup>
                          </MenuList> */}
                        </Menu>
                      )}
                      {selectedIntegration == '4' && (
                        <Select
                          placeholder="Selecionar repositório"
                          value={newJob.repo_name}
                          onChange={(e) => setNewJob({ ...newJob, repo_name: e.target.value })}
                          style={{ width: '360px' }}
                          disabled={selectedIntegration === '1'}
                          mb={4}
                        >
                          {repos.map(repo => <option key={repo.id_repos} value={repo.reponame}>{repo.reponame}</option>)}
                        </Select>
                      )}
                      {selectedIntegration == '5' && (
                        <Select
                          placeholder="Selecionar repositório"
                          value={newJob.repo_name}
                          onChange={(e) => setNewJob({ ...newJob, repo_name: e.target.value })}
                          style={{ width: '360px' }}
                          disabled={selectedIntegration === '1'}
                          mb={4}
                        >
                          {repos.map(repo => <option key={repo.id_repos} value={repo.reponame}>{repo.reponame}</option>)}
                        </Select>
                      )}
                      {selectedIntegration == '6' && (
                        <Select
                          placeholder="Selecionar repositório"
                          value={newJob.repo_name}
                          onChange={(e) => setNewJob({ ...newJob, repo_name: e.target.value })}
                          style={{ width: '360px' }}
                          disabled={selectedIntegration === '1'}
                          mb={4}
                        >
                          {repos.map(repo => <option key={repo.id_repos} value={repo.reponame}>{repo.reponame}</option>)}
                        </Select>
                      )}
                    </AlertDialogBody>
                    <AlertDialogFooter>
                      <Flex justify="space-between">
                        <Button colorScheme="blue" onClick={handleAddJob} borderRadius="lg" marginRight={2}>Adicionar</Button>
                        <Button onClick={() => setShowModal(false)} borderRadius="lg">Cancelar</Button>
                      </Flex>
                    </AlertDialogFooter>
                  </AlertDialogContent>
                </AlertDialogOverlay>
              </AlertDialog>
            )}
            {showModalUplaod && (
              <AlertDialog isOpen={showModalUplaod} onClose={() => setShowModalUpload(false)}>
                <AlertDialogOverlay>
                  <AlertDialogContent>
                    <AlertDialogHeader fontSize="lg" fontWeight="bold">
                      Carregar arquivos
                    </AlertDialogHeader>
                    <AlertDialogBody>
                      <Flex direction="row" align="stretch" mt={2} spacing={8}></Flex>
                      <FormLabel>Selecione o repositório</FormLabel>
                      <Select
                        placeholder="Selecionar repositório atrelado"
                        value={selectedRepoPath}
                        onChange={(e) => {
                          setSelectedRepoPath(e.target.value);
                        }}
                        width={"360px"}
                      >
                        {repos.map((repo) => (
                          <option key={repo.id_repos} value={repo.repos_path}>
                            {repo.reponame}
                          </option>
                        ))}
                      </Select>
                      <input
                        id="fileInput"
                        type="file"
                        accept=".mp3"
                        style={{ display: 'none' }}
                        multiple
                        onChange={handleFileInputChange}
                      />
                      <AlertDialog isOpen={confirmacaoAberta} onClose={() => setConfirmacaoAberta(false)}>
                        <AlertDialogOverlay>
                          <AlertDialogContent>
                            <AlertDialogHeader fontSize="lg" fontWeight="bold">
                              Confirmação
                            </AlertDialogHeader>
                            <AlertDialogBody>
                              <p>Deseja realmente carregar os seguintes arquivos?</p>
                              {fileToUpload && Array.isArray(fileToUpload) && fileToUpload.length > 0 && (
                                <ul>
                                  {fileToUpload.map((file, index) => (
                                    <li key={index}>{file.name}</li>
                                  ))}
                                </ul>
                              )}
                            </AlertDialogBody>
                            <AlertDialogFooter>

                              <Button
                                colorScheme="red"
                                onClick={() => setConfirmacaoAberta(false)}
                                borderRadius="lg">Cancelar
                              </Button>

                              <Button
                                colorScheme="blue"
                                onClick={() => {
                                  setConfirmacaoAberta(false);
                                  handleFileUpload();
                                }}
                                ml={3}
                                borderRadius="lg"
                              >Confirmar
                              </Button>
                            </AlertDialogFooter>
                          </AlertDialogContent>
                        </AlertDialogOverlay>
                      </AlertDialog>
                      <LoadingIndicator isLoading={loading} />
                      {uploadAlert && (
                        <Box mt={4}>
                          {uploadAlert}
                        </Box>
                      )}
                    </AlertDialogBody>
                    <AlertDialogFooter>
                      <Flex justify="space-between">
                        <Button colorScheme="blue" onClick={abrirConfirmacao} borderRadius="lg" marginRight={2}>Adicionar</Button>
                        <Button onClick={() => setShowModalUpload(false)} borderRadius="lg">Cancelar</Button>
                      </Flex>
                    </AlertDialogFooter>
                  </AlertDialogContent>
                </AlertDialogOverlay>
              </AlertDialog>
            )}
          </VStack>
        </CardHeader>
        <Flex direction="row" align="stretch" mt={4} spacing={4}></Flex>
        <CardBody style={{ overflow: 'scroll' }}>

          <Table variant='simple' color={textColor} >
            <Thead>
              <Tr my='.8rem' pl='0px' color='gray.400'>
                {["NOME", "FICHA", "REPOSITÓRIO", "CAMPANHA", "Status", "EM FILA", "Habilitar", "INTEGRAÇÃO", "QTD PROTOCOLO", "FILA", "METADADOS", "AÇÕES"].map((caption, idx) => {
                  return (
                    <Th key={idx} ps={idx === 0 ? "0px" : null}>
                      <nobr>{caption}</nobr>
                    </Th>
                  );
                })}
              </Tr>
            </Thead>
            <Tbody>
              {data.map((job) => {
                return (
                  <Tr key={job.idtranscript_scheduller}>
                    <Td>
                      <nobr>
                        {job.meta === "SIM" ? (
                          <ChakraLink as={Link} to={`/admin/metadados/${job.idtranscript_scheduller}`} color="blue.500" _hover={{ textDecoration: 'underline' }}>
                            {job.job_name}
                          </ChakraLink>
                        ) : (
                          <span>{job.job_name}</span>
                        )}
                      </nobr>
                    </Td>
                    <Td><nobr>{job.audit_name}</nobr></Td>
                    <Td><nobr>{job.repository_name}</nobr></Td>
                    <Td><nobr>{job.campanha_nome}</nobr></Td>
                    <Td><nobr>{job.transcript_worker_queue_insert_status}</nobr></Td>
                    <Td><nobr>
                      <Text>{job.queue_status_count}</Text>
                    </nobr>
                    </Td>
                    <Td><nobr>
                      <FormControl display="flex" alignItems="center">
                        <FormLabel mb="0" mr={2}>
                          {job.state === 1 ? "Habilitado" : "Desabilitado"}
                        </FormLabel>
                        <Switch
                          isChecked={job.state === 1}
                          onChange={() => toggleJobState(job)}
                        />
                      </FormControl>
                    </nobr>
                    </Td>
                    <Td>{job.integration}</Td>
                    <Td>{job.qtd_protocol}</Td>
                    <Td>{job.queue_id}</Td>
                    <Td>{job.meta}</Td>
                    <Flex alignItems="center" justifyContent="center">
                      <IconButton icon={<DeleteIcon />} onClick={() => deleteFicha(job)} />
                    </Flex>
                  </Tr>
                );
              })}
            </Tbody>
          </Table>
        </CardBody>
      </Card>
    </Flex>
  );
}
export default Jobs;